<template>
  <div class="brand-navigation">
    <div class="contents navigation-contents">
      <div
        class="navigation-title"
        :class="{ active: proActive }"
        @click="tabItem(2)"
      >
        <span><i class="icon iconfont icon-Vector"></i>产品</span>
      </div>
      <div
        class="navigation-title"
        :class="{ active: comActive }"
        @click="tabItem(1)"
      >
        <span><i class="icon iconfont icon-Subtract"></i>品牌主页</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 1,
    };
  },
  computed: {
    comActive: function () {
      return this.active == 1;
    },
    proActive: function () {
      return this.active == 2;
    },
  },
  methods: {
    tabItem(val) {
      this.active = val;
      this.$emit("tabItem", val);
    },
    setActive(val) {
      window.scrollTo(0, 0);
      this.active = val;
    },
  },
};
</script>

<style scoped>
.brand-navigation {
  width: 100%;
  border-bottom: 1px solid #2655ae;
  overflow: hidden;
}
.navigation-contents {
  margin-top: 5px;
  overflow: hidden;
  width: 600px;
  display: flex;
  justify-content: center;
  flex-direction: row-reverse;
}
.navigation-contents .navigation-title {
  /* width: 50%; */
  text-align: center;
  float: left;
  line-height: 2;
  font-size: 20px;
  cursor: pointer;
  margin-left: -43px;
}
.navigation-title .icon {
  font-size: 18px;
  margin-right: 8px;
}
.navigation-title span {
  display: inline-block;
  width: 217px;
  height: 48px;
  line-height: 50px;
  background: url(/static/icon/bj2.png) no-repeat;
  background-size: 100% 100%;
  color: #333333;
  font-size: 20px;
}
.navigation-title.active span {
  color: #fff;
  background: url(/static/icon/bj1.png) no-repeat;
  background-size: 100% 100%;
}
.active span {
  color: #2655ae;
}
</style>


// WEBPACK FOOTER //
// src/components/brand/BrandNavigation.vue